import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap cursor-pointer">
              <span className="w-9 h-9 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg">
                <i className="ri-movie-2-line text-lg"></i>
              </span>
              <span className="text-xl font-heading font-bold text-background-50">屁屁影院</span>
            </Link>
            <p className="text-sm text-background-300 leading-relaxed max-w-md">
              屁屁影院作为知名免费影视站，汇聚电影大全，高清免费在线观看不缓冲，最新大片即点即播，热门经典应有尽有，秒速播放，极速加载，追剧观影更畅快。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-background-300 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">首页</Link>
              <Link to="/category/all" className="text-sm text-background-300 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">电影分类</Link>
              <Link to="/about" className="text-sm text-background-300 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门分类</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/category/action" className="text-sm text-background-300 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">动作片</Link>
              <Link to="/category/comedy" className="text-sm text-background-300 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">喜剧片</Link>
              <Link to="/category/scifi" className="text-sm text-background-300 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">科幻片</Link>
              <Link to="/category/animation" className="text-sm text-background-300 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">动画片</Link>
            </div>
          </div>
        </div>

        <div className="py-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-400">© 2026 屁屁影院 版权所有</p>
          <p className="text-xs text-background-500 max-w-xl text-center sm:text-right">
            免责声明：本站所有视频资源均来自互联网收集，仅供网友学习交流，不提供影视资源存储和上传服务。如侵犯了您的权益，请联系我们删除。
          </p>
        </div>
      </div>
    </footer>
  );
}